<template>
  <b-form>
    <b-form-group v-if="!model.editNodeDisabled" label="Nome">
      <b-input v-model="model.name" :disabled="model.editNodeDisabled"/>
    </b-form-group>
    <b-form-group label="Tipo">
      <b-select v-model="model.type" :options="typeOptions" size="sm"/>
    </b-form-group>

    <div v-if="model.type !== 'Array'">
      <b-form-group label="Campo">
        <b-select v-model="model.field" size="sm" :options="fieldOptions"/>
      </b-form-group>

      <div class="row">
        <div class="col">
          <b-form-group label="Atributo">
            <b-checkbox v-model="model.isAttribute" switch/>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group label="Referência">
            <b-checkbox v-model="model.isForeingKey" switch/>
          </b-form-group>
        </div>
      </div>

    </div>

    <div v-if="model.isForeingKey">
      <b-form-group label="Campo">
        <b-input v-model="model.foreingNode" placeholder="Arquivo:pedido:amostras:amostra"/>
      </b-form-group>
      <b-form-group label="">
        <b-input v-model="model.foreingField" placeholder="identificadorAmostra"/>
      </b-form-group>
    </div>
    <b-button variant="outline-success" @click="$emit('update', model)" block>Salvar</b-button>
  </b-form>
</template>

<script>
export default {
  name: "Form",
  props: {
    model: {
      type: Object
    }
  },
  data() {
    return {
      typeOptions: ['Array', 'Object', 'Info'], //, 'DateTime', 'Number', 'Boolean']
      fieldOptions: [
        {
          label: 'Recipiente',
          options: [
            {text: 'Objeto', value: 'recipient.object'},
            {text: 'Identificador do Recipiente', value: 'recipient.identifier'},
            {text: 'Código do Recipiente', value: 'recipient.code'},
            {text: 'Descrição do Recipiente', value: 'recipient.description'},
            {text: 'Código do Material', value: 'recipient.specimenCode'},
            {text: 'Local de Coleta', value: 'recipient.serviceLocationName'},
            {text: 'Número do Atendimento', value: 'recipient.numeroAtendimento'}
            // { text: 'Processado', value: 'recipient.processed' },
          ]
        },
        {
          label: 'Solicitação',
          options: [
            {text: 'Objeto', value: 'order.object'},
            {text: 'Status', value: 'order.status'},
            {text: 'Prioridade', value: 'order.piority'},
            {text: 'Parte do corpo', value: 'order.bodySite'},
            {text: 'Local de origem da solicitação', value: 'order.serviceLocationName'},
          ]
        },
        {
          label: 'Exame',
          options: [
            {text: 'Código do Exame', value: 'exam.examCode'},
            {text: 'Método do Exame', value: 'exam.methodCode'},
            {text: 'Material do Exame', value: 'exam.specimenCode'},
            {text: 'Complemento do Material', value: 'exam.specimenComplement'},
            {text: 'Observação para o Resultado', value: 'exam.resultObservation'}
          ]
        },
        {
          label: 'Paciente',
          options: [
            {text: 'Objeto', value: 'patient.object'},
            {text: 'Identificador do Paciente', value: 'patient.identifier'},
            {text: 'Nome do Paciente', value: 'patient.name'},
            {text: 'Gênero do Paciente', value: 'patient.gender'},
            {text: 'Data de nascimento', value: 'patient.birthday'},
            {text: 'Peso do Paciente', value: 'patient.weight'},
            {text: 'Altura do Paciente', value: 'patient.height'}
          ]
        }
      ]
    }
  }
}
</script>
